import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ICON_REFRESH, ICON_SEARCH } from '../../extras/icons';
//Redux
import { listJudgesAction } from '../../../actions/judgesActions';
import { listInhibitionTypesAction } from '../../../actions/inhibitionTypesActions';

import { ErrorMessage } from '../../extras/toastMessages';
import { MSG_ERROR_SELECT_FILTER } from '../../../constants/messages';
//Función principal
const InhibitionSearch = props => {
    //Tomo los props
    const { setSearch } = props;
    //Inicializo
    const initialFilter = {
        judge: '',
        type: '',
        fecha: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo del store
    const judgesLoading = useSelector( state => state.judges.loading );
    const judges = useSelector( state => state.judges.judges );
    const inhibitionTypesLoading = useSelector( state => state.inhibitionTypes.loading );
    const inhibitionTypes = useSelector( state => state.inhibitionTypes.inhibitionTypes );
    //Inicializo el state local
    const [ filter, setFilter ] = useState(initialFilter);
    //Manejo el cambio de valores
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }
    //Cargo los parámetros
    const loadParameters = () => {
        //Seteo los params
        const params = {
            search: 'activo:1',
            sort: 'apellido:asc,nombre:asc'
        }
        //Llamo al dispatch
        dispatch( listJudgesAction(params) );
        //Seteo los params
        const paramsTypes = {
            search: 'activo:1',
            sort: 'descripcion:asc'
        }
        //Llamo al dispatch
        dispatch( listInhibitionTypesAction(paramsTypes) );
    }
    //Al inicio cargo
    useEffect(() => {
        //Cargo los parámetros
        loadParameters();
    }, []);
    //Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        //Inicializo 
        let newSearch = '';
        //Verifico filtros
        //Juez
        if(filter.judge !== ''){
            newSearch += `juez.id:${filter.judge}`;
        }
        //Tipo
        if(filter.type !== ''){
            newSearch += `${newSearch !== '' ? `${newSearch},` : ''}tipo.id:${filter.type}`;
        }
        //Verifico el filtro de fecha
        if(filter.fecha !== ''){
            //Inicializo
            newSearch += `${newSearch !== '' ? ',' : ''}fecha:${filter.fecha}`;
        }
        
        //Me fijo si hay filtros
        if(newSearch === ''){
            //Error
            ErrorMessage(MSG_ERROR_SELECT_FILTER);
        }else{
            //Seteo la búsqueda
            setSearch(newSearch);
        }
    }
    //Manejo el limpiar
    const handleClear = e => {
        e.preventDefault();
        setFilter(initialFilter);
        setSearch('');
    }
    //Renderizo
    return (
        <div className="row">
            <form onSubmit={handleSubmit} className="col">
                <div className="row mb-2">
                    <div className="col-md-2">
                        <label htmlFor="fecha" >Fecha</label>
                        <input type="date" className="form-control" id="fecha" name="fecha" onChange={handleChange} value={filter.fecha} disabled={judgesLoading} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <select 
                            name="judge" 
                            className="form-control" 
                            onChange={handleChange} 
                            value={filter.judge} 
                            disabled={judgesLoading || inhibitionTypesLoading}
                        >
                            <option value="">Todos los Jueces/Magistrados</option>
                            {
                                judges ? (
                                    judges.map(judge => (
                                        <option value={judge.id} key={`tsj${judge.id}`}>
                                            {`${judge.apellido}, ${judge.nombre}`}
                                        </option>
                                    ))
                                ) : null
                            }
                        </select>
                    </div>
                    <div className="col-md-3">
                        <select 
                            name="type" 
                            className="form-control" 
                            onChange={handleChange} 
                            value={filter.type} 
                            disabled={judgesLoading || inhibitionTypesLoading}
                        >
                            <option value="">Todos los Tipos</option>
                            {
                                inhibitionTypes ? (
                                    inhibitionTypes.map(inhibitionType => (
                                        <option value={inhibitionType.id} key={`tst${inhibitionType.id}`}>
                                            { inhibitionType.descripcion }
                                        </option>
                                    ))
                                ) : null
                            }
                        </select>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="primary"
                            type="submit"
                            block
                            disabled={judgesLoading || inhibitionTypesLoading}
                        >
                            <ICON_SEARCH />
                        </Button>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="warning"
                            type="button"
                            onClick={handleClear}
                            block
                            disabled={judgesLoading || inhibitionTypesLoading}
                        >
                            <ICON_REFRESH />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default InhibitionSearch;